import observeStore from '../observeStore';

function onAdvancedOrderedListChainUpdated (bulletAndOrderedList) {
  if (!INKIVE.C.BOOK.initialized) return;

  INKIVE.AdvancedOrderedListFactory.calculateOrderTrackingFromPreviousPages();
  INKIVE.PageFactory.saveProjectState({ bullet_and_ordered_list: bulletAndOrderedList });
}

function onAnimationUpdated (hasAnimation) {
  if (!INKIVE.C.SHOW_ANIMATION) return;

  const previewAnimationButton = document.querySelector('button#preview-animations');
  previewAnimationButton && previewAnimationButton.classList.toggle('hidden', !hasAnimation);
}

export function configureObserver (store) {
  observeStore(
    store,
    (state) => state.metadata?.bullet_and_ordered_list,
    onAdvancedOrderedListChainUpdated
  );
  observeStore(
    store,
    (state) => state.metadata?.animation,
    onAnimationUpdated
  );
}
